import type { CandidateFacet } from '@/types/engineer'
import { cn } from '@/lib/utils'
import { EvidenceStateBadge } from '@/components/Shared/EvidenceStateBadge'

interface FacetCardProps {
  facet: CandidateFacet
}

export function FacetCard({ facet }: FacetCardProps) {
  // facet.watchpoints rides along in props for future FitBrief LLM evaluation — not rendered here.
  return (
    <div
      className={cn(
        'rounded-[13px] border border-border bg-card p-[18px]',
        facet.evidenceState === 'Not Yet Observed' && 'border-dashed',
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <span className="font-sans text-[15px] font-semibold text-foreground">{facet.facetType}</span>
        <EvidenceStateBadge state={facet.evidenceState} className="shrink-0" />
      </div>
      <p className="mt-2 font-sans text-[13.5px] leading-[1.5] text-muted-foreground">
        {facet.facetSummary}
      </p>
      {facet.supportingEvidence.length > 0 && (
        <ul className="mt-3">
          {facet.supportingEvidence.map((item) => (
            <li key={item} className="font-mono text-[11px] leading-[1.5] text-muted-foreground">
              · {item}
            </li>
          ))}
        </ul>
      )}
      {facet.openQuestions.length > 0 && (
        <div className="mt-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground">
            Open questions
          </span>
          <ul className="mt-2">
            {facet.openQuestions.map((question) => (
              <li key={question} className="font-sans text-[12.5px] leading-[1.5] text-foreground">
                <span className="font-semibold text-primary">?</span> {question}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground">
        confidence · {facet.confidenceLevel}
      </div>
    </div>
  )
}
